// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.border-other-wrapper {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-right:5px;
}
.align-items-vertical{
    align-items:center;
}
.border-radius-wrapper{
    display:grid;
    grid-template-columns: 1fr 50px 50px 1fr;
}
.border-radius-top-left {
    margin: 5px;
    max-width: 33px;
    border-left: 1px solid var(--appbuilder-primary-color);
    border-top: 1px solid var(--appbuilder-primary-color);
}
.border-radius-top-right {
    margin: 5px;
    max-width: 33px;
    border-right: 1px solid var(--appbuilder-primary-color);
    border-top: 1px solid var(--appbuilder-primary-color);
}
.border-radius-bottom-left {
    margin: 5px;
    max-width: 33px;
    border-left: 1px solid var(--appbuilder-primary-color);
    border-bottom: 1px solid var(--appbuilder-primary-color);
}
.border-radius-bottom-right {
    margin: 5px;
    max-width:33px;
    border-right: 1px solid var(--appbuilder-primary-color);
    border-bottom: 1px solid var(--appbuilder-primary-color);
}
.single-border-wrapper {
    display: flex;
    flex-direction: row;
    border: 1px solid var(--appbuilder-border-color);
    border-top-left-radius: var(--appbuilder-border-radius-top-left);
    border-top-right-radius: var(--appbuilder-border-radius-top-right);
    border-bottom-left-radius: var(--appbuilder-border-radius-bottom-left);
    border-bottom-right-radius: var(--appbuilder-border-radius-bottom-right);
    height:45px;
    width:-moz-fit-content;
    width:fit-content;

}
.line-left {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    border-left: 1px solid var(--appbuilder-border-color);
}
.single-border-wrapper .mdc-button {
    padding:0 5px;
    min-width:unset;
}
.active {
    color: var(--appbuilder-hover-color);
    background-color: var(--appbuilder-primary-color);
}
.no-radius{
    border-radius:0;
}
.selected {
    outline: 2px solid var(--appbuilder-border-color);
    z-index: 2;
}
.showborder{
    border: 1px solid var(--appbuilder-primary-color);
    padding:5px;
    border-radius: 6px;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/borderselection/borderselection.theme.control.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,kCAAkC;IAClC,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,wCAAwC;AAC5C;AACA;IACI,WAAW;IACX,eAAe;IACf,sDAAsD;IACtD,qDAAqD;AACzD;AACA;IACI,WAAW;IACX,eAAe;IACf,uDAAuD;IACvD,qDAAqD;AACzD;AACA;IACI,WAAW;IACX,eAAe;IACf,sDAAsD;IACtD,wDAAwD;AAC5D;AACA;IACI,WAAW;IACX,cAAc;IACd,uDAAuD;IACvD,wDAAwD;AAC5D;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,gDAAgD;IAChD,gEAAgE;IAChE,kEAAkE;IAClE,sEAAsE;IACtE,wEAAwE;IACxE,WAAW;IACX,sBAAiB;IAAjB,iBAAiB;;AAErB;AACA;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,qDAAqD;AACzD;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;IACI,oCAAoC;IACpC,iDAAiD;AACrD;AACA;IACI,eAAe;AACnB;AACA;IACI,iDAAiD;IACjD,UAAU;AACd;AACA;IACI,iDAAiD;IACjD,WAAW;IACX,kBAAkB;AACtB","sourcesContent":[".border-other-wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    margin-right:5px;\n}\n.align-items-vertical{\n    align-items:center;\n}\n.border-radius-wrapper{\n    display:grid;\n    grid-template-columns: 1fr 50px 50px 1fr;\n}\n.border-radius-top-left {\n    margin: 5px;\n    max-width: 33px;\n    border-left: 1px solid var(--appbuilder-primary-color);\n    border-top: 1px solid var(--appbuilder-primary-color);\n}\n.border-radius-top-right {\n    margin: 5px;\n    max-width: 33px;\n    border-right: 1px solid var(--appbuilder-primary-color);\n    border-top: 1px solid var(--appbuilder-primary-color);\n}\n.border-radius-bottom-left {\n    margin: 5px;\n    max-width: 33px;\n    border-left: 1px solid var(--appbuilder-primary-color);\n    border-bottom: 1px solid var(--appbuilder-primary-color);\n}\n.border-radius-bottom-right {\n    margin: 5px;\n    max-width:33px;\n    border-right: 1px solid var(--appbuilder-primary-color);\n    border-bottom: 1px solid var(--appbuilder-primary-color);\n}\n.single-border-wrapper {\n    display: flex;\n    flex-direction: row;\n    border: 1px solid var(--appbuilder-border-color);\n    border-top-left-radius: var(--appbuilder-border-radius-top-left);\n    border-top-right-radius: var(--appbuilder-border-radius-top-right);\n    border-bottom-left-radius: var(--appbuilder-border-radius-bottom-left);\n    border-bottom-right-radius: var(--appbuilder-border-radius-bottom-right);\n    height:45px;\n    width:fit-content;\n\n}\n.line-left {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n    border-left: 1px solid var(--appbuilder-border-color);\n}\n.single-border-wrapper .mdc-button {\n    padding:0 5px;\n    min-width:unset;\n}\n.active {\n    color: var(--appbuilder-hover-color);\n    background-color: var(--appbuilder-primary-color);\n}\n.no-radius{\n    border-radius:0;\n}\n.selected {\n    outline: 2px solid var(--appbuilder-border-color);\n    z-index: 2;\n}\n.showborder{\n    border: 1px solid var(--appbuilder-primary-color);\n    padding:5px;\n    border-radius: 6px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
